import * as tslib_1 from "tslib";
import AmCharts from "../AmCharts";
import cx from 'classnames';
import * as React from 'react';
import Styles from "./Charts.css";
import { DEFAULT_SETTINGS, LEGEND_SETTINGS, RESPONSIVE_SETTINGS, VALUE_AXIS_SETTINGS } from './constants';
import Utils from './utils/common';

var getDataMax = function getDataMax(data) {
  return data.reduce(function (result, item) {
    var dataItemValues = Object.keys(item).map(function (itemKey) {
      return Number(item[itemKey]);
    }).filter(function (itemValue) {
      return itemValue;
    });
    var dataItemMax = Math.max.apply(Math, tslib_1.__spread(dataItemValues));
    return Math.max(dataItemMax, result);
  }, 0);
};

var BarChart =
/** @class */
function (_super) {
  tslib_1.__extends(BarChart, _super);

  function BarChart() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.getOptions = function () {
      var _a = _this.props,
          title = _a.title,
          data = _a.data,
          unit = _a.unit,
          legendPosition = _a.legendPosition,
          enabledLegendItems = _a.enabledLegendItems,
          timeRange = _a.timeRange,
          disableDownload = _a.disableDownload,
          legendEnabled = _a.legendEnabled,
          responsive = _a.responsive,
          stacked = _a.stacked,
          rotated = _a.rotated,
          onGraphItemClick = _a.onGraphItemClick;
      var _b = data.meta.chartOptions,
          chartOptions = _b === void 0 ? {} : _b;

      var options = tslib_1.__assign({}, DEFAULT_SETTINGS, {
        type: 'serial',
        dataProvider: data.data,
        categoryField: data.meta.categoryField,
        rotate: rotated,
        newStack: true
      }, chartOptions);

      options.chartCursor = tslib_1.__assign({}, DEFAULT_SETTINGS.chartCursor || {}, {
        valueLineEnabled: true
      }, chartOptions.chartCursor);

      if (onGraphItemClick) {
        options.listeners = [{
          event: 'clickGraphItem',
          method: onGraphItemClick
        }];
      } // ------------------------------
      // Graphs
      // ------------------------------


      options.graphs = data.meta.items.map(function (itemName, i) {
        var graph = tslib_1.__assign({
          type: 'column',
          fillAlphas: 1,
          valueField: data.meta.valueField || itemName,
          colorField: 'color',
          lineAlpha: 0,
          hidden: enabledLegendItems && enabledLegendItems.every(function (item) {
            return item.label !== itemName;
          })
        }, chartOptions.graphs || {});

        if (stacked) {
          graph.labelText = '[[value]]';
        }

        if (data.meta.precision) {
          graph.precision = data.meta.precision;
        }

        if (data.meta.itemColors) {
          graph.lineColor = data.meta.itemColors[i];
        }

        if (!data.meta.noTitle) {
          graph.title = itemName;
        }

        if (data.meta.hiddenItems) {
          graph.hidden = data.meta.hiddenItems[i];
        } // TODO: define where should balloon live. There's one more balloon in chartUtils


        graph.balloonText = [graph.title ? '[[title]]' : '[[category]]', "<b>[[value]] " + (unit || '') + "</b>"].join('<br>');
        return graph;
      }); // ------------------------------
      // Value axis
      // ------------------------------

      var valueAxis = _this.getValueAxisConfig();

      if (unit === 'minutes') {
        valueAxis.labelFunction = Utils.secondsToMinutes;
      }

      options.valueAxes = [valueAxis]; // ------------------------------
      // Category axis
      // ------------------------------

      options.categoryAxis = tslib_1.__assign({
        axisAlpha: 0,
        gridAlpha: 0,
        // tickLength: 10,
        autoGridCount: false,
        boldPeriodBeginning: false,
        autoRotateCount: 8,
        autoRotateAngle: 45,
        parseDates: undefined
      }, chartOptions.categoryAxis || {});
      var dateFormat = data.meta.dateFormat;

      if (dateFormat) {
        if (dateFormat !== 'auto') {
          options.dataDateFormat = dateFormat;
        }

        options.categoryAxis.parseDates = true;
      } // ------------------------------
      // Legend
      // ------------------------------


      if (legendEnabled) {
        options.legend = tslib_1.__assign({}, LEGEND_SETTINGS, {
          enabled: legendPosition !== 'none',
          position: Utils.getLegendPosition(legendPosition)
        }, chartOptions.legend || {});

        if (data.meta.legend) {
          options.legend.data = data.meta.legend;
        }
      } // ------------------------------
      // Responsive
      // ------------------------------


      if (responsive) {
        options.responsive = tslib_1.__assign({}, RESPONSIVE_SETTINGS, {
          enabled: true
        });
      } // ------------------------------
      // Export
      // ------------------------------


      if (!disableDownload) {
        options.export = Utils.getExportOptions(title, timeRange);
      }

      return options;
    };

    return _this;
  }

  BarChart.prototype.getValueAxisConfig = function () {
    var _a = this.props,
        stacked = _a.stacked,
        data = _a.data;
    var _b = data.meta,
        minimum = _b.minimum,
        maximum = _b.maximum,
        unit = _b.unit,
        _c = _b.chartOptions,
        chartOptions = _c === void 0 ? {} : _c;
    return tslib_1.__assign({}, VALUE_AXIS_SETTINGS, {
      stackType: stacked ? 'regular' : 'none',
      axisAlpha: 0,
      dashLength: 1,
      position: 'bottom',
      unit: unit || null,
      minimum: minimum || 0,
      maximum: this.getValueAxisMaximum(maximum)
    }, chartOptions.valueAxis || {});
  };

  BarChart.prototype.getValueAxisMaximum = function (configMaximum) {
    var data = this.props.data;
    var dataMax = getDataMax(data.data);

    if (dataMax < 2) {
      return Math.ceil(dataMax);
    } else {
      return configMaximum;
    }
  };

  BarChart.prototype.render = function () {
    var _a = this.props,
        height = _a.height,
        className = _a.className;

    var style = tslib_1.__assign({}, height ? {
      height: height
    } : {});

    var options = this.getOptions();
    return React.createElement("div", {
      className: cx(Styles.barChart, className)
    }, React.createElement(AmCharts.React, {
      style: style,
      options: options
    }));
  };

  return BarChart;
}(React.PureComponent);

export default BarChart;